import React from 'react';
import Hero from './Hero';
import ChargesTables from './ChargesTables'
function PricingPage() {
    return (
        <>
        <Hero/>
        <ChargesTables/>
        </>
    );
}

export default PricingPage;